const DISPOSABLE_EMAIL_DOMAINS = new Set([
  'mailinator.com',
  'guerrillamail.com',
  '10minutemail.com',
  'temp-mail.org',
  'tempmail.com',
  'yopmail.com',
  'throwawaymail.com',
  'sharklasers.com',
  'trashmail.com',
  'dispostable.com',
  'fakeinbox.com',
  'getnada.com',
  'mintemail.com',
  'maildrop.cc',
  'mytemp.email',
  'tempmailo.com',
  'emailondeck.com',
  'spambox.us',
  'mailnesia.com',
  'moakt.com',
]);

const OBVIOUS_PLACEHOLDERS = new Set([
  'test',
  'testing',
  'demo',
  'asdf',
  'qwerty',
  'admin',
  'user',
  'unknown',
  'none',
  'na',
  'n/a',
  'null',
  'fake',
  'xxx',
]);

export const normalizeEmail = (email = '') => email.trim().toLowerCase();

export const validateEmail = (email = '') => {
  const normalized = normalizeEmail(email);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(normalized);
};

export const isDisposableEmail = (email = '') => {
  const normalized = normalizeEmail(email);
  const [, domain = ''] = normalized.split('@');
  return DISPOSABLE_EMAIL_DOMAINS.has(domain);
};

const hasRunawayRepeatingChars = (value = '') => /(.)\1{5,}/.test(value.toLowerCase());

const isPlaceholderValue = (value = '') => OBVIOUS_PLACEHOLDERS.has(value.toLowerCase().trim());

export const validatePersonName = (name = '') => {
  const trimmed = name.trim();
  if (!trimmed) return 'This field is required';
  if (trimmed.length < 2) return 'Must be at least 2 characters';
  if (hasRunawayRepeatingChars(trimmed)) return 'Looks invalid';
  if (isPlaceholderValue(trimmed)) return 'Please enter your real name';
  if (!/^[a-zA-Z][a-zA-Z\s'-]*$/.test(trimmed)) return 'Use letters only';
  return '';
};

export const validateCompanyName = (company = '') => {
  const trimmed = company.trim();
  if (!trimmed) return 'Company name is required';
  if (trimmed.length < 2) return 'Company name must be at least 2 characters';
  if (hasRunawayRepeatingChars(trimmed)) return 'Company name looks invalid';
  if (isPlaceholderValue(trimmed)) return 'Please enter your real company name';
  return '';
};

export const normalizePhone = (phone = '') => {
  const trimmed = phone.trim();
  if (!trimmed) return '';
  const hasPlus = trimmed.startsWith('+');
  const digits = trimmed.replace(/\D/g, '');
  return `${hasPlus ? '+' : ''}${digits}`;
};

export const validatePhone = (phone = '') => {
  const normalized = normalizePhone(phone);
  if (!normalized) return 'Phone number is required';
  const digits = normalized.replace(/\D/g, '');
  if (digits.length < 8 || digits.length > 15) return 'Enter a valid phone number';
  if (hasRunawayRepeatingChars(digits)) return 'Phone number looks invalid';
  return '';
};

export const validatePasswordStrength = (password = '') => {
  const issues = [];
  if (password.length < 10) issues.push('at least 10 characters');
  if (!/[a-z]/.test(password)) issues.push('one lowercase letter');
  if (!/[A-Z]/.test(password)) issues.push('one uppercase letter');
  if (!/[0-9]/.test(password)) issues.push('one number');
  if (!/[^A-Za-z0-9]/.test(password)) issues.push('one symbol');

  const lower = password.toLowerCase();
  const weakFragments = ['password', 'qwerty', '123456', 'letmein', 'welcome'];
  if (weakFragments.some((fragment) => lower.includes(fragment))) {
    issues.push('avoid common words or sequences');
  }

  return {
    valid: issues.length === 0,
    issues,
  };
};

